import { createRouter, createWebHistory } from 'vue-router'
import  store  from '../store';



 


const router = createRouter({
  history: createWebHistory(),
  routes:  [
    {
      path: '/:id',
      name: 'Home',
      component: () => import('../views/HomeView.vue')
    },
    {
      path: '/reg',
      name: 'Reg',
      component: () => import('../views/Reg.vue')
    },
    
    {
      path: '/selectoptions',
      name: 'SelectOptions',
      component: () => import('../views/SelectOptions.vue'),
      meta: {rutaProtegida: true}
    },
   

    {
      path: '/decode',
      name: 'decode',
      component: () => import('../views/DecodeQr.vue')
    },

    {
      path: '/download',
      name: 'download',
      component: () => import('../views/Download.vue')
    },


    {
      path: '/codeGen',
      name: 'codeGen',
      component: () => import('../views/CodeGenerate.vue')
    },

    {
      path: '/resumen',
      name: 'resumen',
      component: () => import('../views/Resumen.vue')
    },
   
    
    {
      path: '/:pathMatch(.*)*',
      name: 'nofound',
      component: () => import('../views/HomeView.vue')
    },
    
   
    
  ]
  
})

router.beforeEach(((to,from,next) =>{
  if (to.meta.rutaProtegida) {
    if (!store.getters.pass) {

      next()
    }else{
      next('/home')
    }
  }else{
    next()
  }

}))

export default router
